<template>
  <v-app id="inspire">
    <v-main class="my-auto">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>实验教学批改系统</v-toolbar-title>
                <div class="flex-grow-1"></div>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" @submit.prevent="validate">
                  <v-text-field
                    label="用户名"
                    name="username"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="username"
                    :rules="username_rules"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    label="密码"
                    name="password"
                    prepend-icon="mdi-lock-question"
                    type="password"
                    v-model="password"
                    :rules="password_rules"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <!-- <v-btn color=" darken-1" text @click="forgotPassword"
                  >忘记密码</v-btn
                > -->
                <v-btn color="primary" @click="validate"> 登录 </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-snackbar v-model="alert" :color="alertColor">
      {{ alertMessage }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    username: '',
    password: '',
    username_rules: [value => !!value || '必填.'],
    password_rules: [value => !!value || '必填.']
  }),
  computed: {
    ...mapGetters(['alert', 'alertColor', 'alertMessage'])
  },
  methods: {
    ...mapActions(['login']),
    validate() {
      if (this.$refs.form.validate()) {
        this.login({ username: this.username, password: this.password });
      }
    },
    forgotPassword() {
      this.$router.push('/forgotpassword');
    }
  }
};
</script>
